/**
 * FAQ 서비스
 */
import { db } from '../firebase/config';
import {
  collection, doc, getDocs, addDoc, updateDoc, deleteDoc,
  query, orderBy, serverTimestamp,
} from 'firebase/firestore';

const COL = 'faqs';

// ───── FAQ 목록 (카테고리 필터) ─────
export const getFaqs = async (category = '전체') => {
  const q = query(collection(db, COL), orderBy('sortOrder', 'asc'));
  const snap = await getDocs(q);
  const all = snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
    date: d.data().updatedAt?.toDate?.()?.toISOString().slice(0, 10) || '',
  }));

  const cat = (category || '전체').replace('#', '');
  if (cat === '전체') return all;
  return all.filter((f) => f.category === cat);
};

// ───── 전체 목록 (관리자용) ─────
export const getAllFaqs = async () => {
  const q = query(collection(db, COL), orderBy('sortOrder', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
    date: d.data().updatedAt?.toDate?.()?.toISOString().slice(0, 10) || '',
  }));
};

// ───── FAQ 등록 ─────
export const createFaq = async (data) => {
  const ref = await addDoc(collection(db, COL), {
    category: data.category || '',
    question: data.question,
    answer: data.answer,
    sortOrder: data.sortOrder || 0,
    isPublished: data.isPublished !== false,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
};

// ───── FAQ 수정 ─────
export const updateFaq = async (id, data) => {
  await updateDoc(doc(db, COL, id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};

// ───── FAQ 삭제 ─────
export const deleteFaq = async (id) => {
  await deleteDoc(doc(db, COL, id));
};

// ───── FAQ 카테고리 목록 ─────
export const getFaqCategories = async () => {
  const snap = await getDocs(collection(db, COL));
  const cats = new Set();
  snap.docs.forEach((d) => {
    const cat = d.data().category;
    if (cat) cats.add(cat);
  });
  return ['전체', ...Array.from(cats).map((c) => `#${c}`)];
};
